import Vue from 'vue'

const $utils = {
    isMobile () {
        return window.app.$vuetify.breakpoint.name === 'xs'
    },
    isTablet () {
        return (
            window.app.$vuetify.breakpoint.name === 'sm' ||
            window.app.$vuetify.breakpoint.name === 'md'
        )
    },
    isPC () {
        return (
            window.app.$vuetify.breakpoint.name === 'lg' ||
            window.app.$vuetify.breakpoint.name === 'xl'
        )
    },
    isNotMobile () {
        return !this.isMobile()
    },
    isEqualValue (o1, o2) {
        return JSON.stringify(o1) === JSON.stringify(o2)
    }
}
Vue.prototype.$utils = $utils

export default $utils